import { parse } from 'date-fns';

export const hhmmssToMinutes = timeString => {
  const parsedTime = parse(timeString, 'HH:mm:ss', new Date(0));

  const totalMinutes =
    parsedTime.getHours() * 60 + // Convert hours to minutes
    parsedTime.getMinutes() + // Add the minutes
    parsedTime.getSeconds() / 60; // Include seconds as fractional minutes

  return totalMinutes;
};
